export function addIdsToSections() {
  $(".scene-1").attr("id", "jon-rye");
  $(".scene-2").attr("id", "new-whisky-experience");
  $(".scene-evidence").attr("id", "nose-and-taste");
  $(".scene-3").attr("id", "the-distiller");
  $(".scene-4").attr("id", "signature-serves");
  $(".scene-5").attr("id", "more-than-it-looks");
  $(".scene-6").attr("id", "note-from-jon");

  scrollToId();
}

function freezeScrubbedTriggers(freeze) {
  freezeScrubbedTriggers._frozen ||= [];
  const frozen = freezeScrubbedTriggers._frozen;
  if (freeze) {
    ScrollTrigger.getAll().forEach((st) => {
      if (!st.vars || !st.vars.scrub) return;
      if (st.animation && !st.animation.paused()) {
        st.animation.pause();
        frozen.push(st);
      }
    });
  } else {
    ScrollTrigger.update();
    frozen.forEach((st) => st.animation && st.animation.play(0).pause());
    frozen.length = 0;
  }
}

function scrollToId() {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const MENU = document.querySelector(".main_menu");
  const UPDATE_HASH = false; // << set to true if you want #slug in the URL

  const headerOffset = () => {
    const h = document.querySelector(".site-header");
    return h ? h.getBoundingClientRect().height : 0;
  };

  const getAnchorEl = (slug) =>
    document.querySelector(`.st-start[data-st-id="${slug}"]`) || document.getElementById(`${slug}-start`) || document.getElementById(slug);

  function stripHash() {
    // remove #... but preserve path & query
    history.replaceState(null, "", location.pathname + location.search);
  }

  function scrollToSlug(slug) {
    const el = getAnchorEl(slug);
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const y = window.pageYOffset + rect.top - headerOffset();

    freezeScrubbedTriggers(true);

    gsap.killTweensOf(window);
    gsap.to(window, {
      duration: 0.8,
      ease: "power2.out",
      scrollTo: { y, autoKill: false },
      overwrite: "auto",
      onComplete: () => {
        freezeScrubbedTriggers(false);
        if (UPDATE_HASH) {
          history.replaceState(null, "", `#${slug}`);
        } else {
          stripHash();
        }
      },
    });
  }

  function wireMenu() {
    if (!MENU) return;
    MENU.addEventListener("click", (e) => {
      const a = e.target.closest('a[href*="#"]');
      if (!a) return;

      const url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname) return; // let browser navigate across pages

      const slug = url.hash.slice(1);
      if (!slug) return;

      e.preventDefault(); // stop the browser from adding #slug
      scrollToSlug(slug);
    });
  }

  function handleDeepLink() {
    const slug = location.hash && location.hash.slice(1);
    if (!slug) return;

    // Prevent native jump on first paint: strip hash ASAP if we won’t keep it
    if (!UPDATE_HASH) {
      // Do it before measuring to avoid layout flicker
      history.replaceState(null, "", location.pathname + location.search);
    }

    requestAnimationFrame(() => scrollToSlug(slug));
  }

  wireMenu();
  handleDeepLink();

  window.addEventListener("load", () => ScrollTrigger.refresh());
  window.addEventListener("resize", () => ScrollTrigger.refresh());
}
